import React, { useState } from "react";

const SubscriptionPlans = () => {
  const [planType, setPlanType] = useState("monthly");

  const plans = {
    monthly: [
      {
        title: "Base Plan",
        price: "₹150",
        badge: "BASE PLAN",
        benefits: [
          "Access App Features",
          "Limited Usage Or Access (e.g: Limited Number Of Items, Standard Customer Support).",
        ],
        color: "bg-primary",
      },
      {
        title: "Premium Plan",
        price: "₹450",
        badge: "PREMIUM",
        benefits: [
          "Access To All App Features, Swiggy, Zomato Integration",
          "Unlimited Data Access",
          "Priority Customer Support.",
        ],
        color: "bg-primary",
      },
    ],
    yearly: [
      {
        title: "Base Plan",
        price: "₹1,500",
        badge: "BASE PLAN",
        discount: "Save ₹300",
        benefits: ["Same Benefits As The Monthly Plan But Offered At A 17% Discount."],
        color: "bg-primary",
      },
      {
        title: "Premium Plan",
        price: "₹4,500",
        badge: "PREMIUM",
        discount: "Save ₹900",
        benefits: ["Same Benefits As The Monthly Plan But Offered At A 17% Discount."],
        color: "bg-primary",
      },
    ],
  };

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h2 className="text-center text-2xl font-semibold mb-2">Subscription</h2>
      <p className="text-center text-gray-500 mb-6">
        Choose the plan that’s right for your business.
      </p>

      <div className="flex justify-center mb-6">
        <div className="flex border rounded-full overflow-hidden">
          <button
            className={`px-6 py-2 font-medium ${
              planType === "monthly" ? "bg-primary text-white" : "bg-white"
            }`}
            onClick={() => setPlanType("monthly")}
          >
            Monthly
          </button>
          <button
            className={`px-6 py-2 font-medium ${
              planType === "yearly" ? "bg-primary text-white" : "bg-white"
            }`}
            onClick={() => setPlanType("yearly")}
          >
            Yearly
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {plans[planType].map((plan, idx) => (
          <div
            key={idx}
            className="border rounded-xl shadow-md overflow-hidden flex flex-col md:flex-row bg-white"
          >
            <div className={`p-6 text-white flex-1 ${plan.color} flex flex-col justify-center`}>
              <div className="text-sm font-semibold uppercase mb-2">{plan.badge}</div>
              <div className="text-3xl font-bold mb-1">{plan.price}</div>
              <div className="text-lg">{plan.title}</div>
              {plan.discount && <div className="text-sm mt-1">({plan.discount})</div>}
            </div>
            <div className="p-6 flex-1">
              <h4 className="font-bold mb-2">You Get</h4>
              <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                {plan.benefits.map((b, i) => (
                  <li key={i}>{b}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-8">
        <button className="bg-primary text-white px-6 py-2 rounded-full text-lg">
          Upgrade
        </button>
      </div>

      <div className="mt-10 bg-white shadow-md p-6 rounded-lg">
        <h3 className="text-primary font-bold text-lg mb-2">Additional Notes:</h3>
        <ol className="list-decimal pl-5 space-y-2 text-sm text-gray-700">
          <li>
            Highlight The Yearly Discounts In Promotional Materials To Encourage Long-Term
            Subscriptions.
          </li>
          <li>
            Offer A Free Trial (E.G., 7 Days For Premium Users) To Attract New Subscribers.
          </li>
          <li>
            Provide In-App Prompts To Upgrade From Base To Premium For Better Visibility Of
            Benefits.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
